import { createSelector } from '@reduxjs/toolkit';
import { selectAppStepDetails } from '@containers/App/selectors';
import { INTERVIEW_STEP_FORM_TYPES } from './constants';
import { findStepFormId } from './utils';
import { joinInterviewSlice } from './slice';
export const selectJoinInterview = createSelector((state) => state, (state) => state[joinInterviewSlice.name]);
export const selectMeetingExternalId = createSelector(selectJoinInterview, (state) => state.meetingExternalId);
export const selectLegacySessionRequestState = createSelector(selectJoinInterview, (state) => state.legacySessionRequestState);
// Pre and post interview forms are both form.type REGISTRATION, so pick by step_form_type.
export const selectPreInterviewFormId = createSelector(selectAppStepDetails, (stepDetails) => findStepFormId(stepDetails?.step_forms, INTERVIEW_STEP_FORM_TYPES.PRE));
